import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoadingSpinnerService, ProjectAnalysisDefinitionService} from '../../services';
import {NgVwuiTableConfig, VwuiModalService} from '@bvgo-ict/vwui-angular';
import {PublishQuickScanVersionModalComponent} from '../../components';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectAnalysisVersion} from "../../models/project-analysis";
import {Observable} from 'rxjs';
import {finalize, map} from 'rxjs/operators';

@Component({
    selector: 'app-page-project-analyses',
    templateUrl: './page-project-analyses.component.html',
    styleUrls: ['./page-project-analyses.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageProjectAnalysesComponent implements OnInit {
    private definitionService = inject(ProjectAnalysisDefinitionService);
    private modalService = inject(VwuiModalService);
    private translateService = inject(TranslateService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    loadingSpinnerService = inject(LoadingSpinnerService);

    public versions$: Observable<ProjectAnalysisVersion[]>;
    public tableConfig: Partial<NgVwuiTableConfig>;
    private projectTypeId: number;

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.projectTypeId = Number(params['projectTypeId']);
            this.setData();
            this.loadVersions();
        });
    }

    private setData(): void {
        this.tableConfig = {
            title: this.translateService.instant('PAGE_PROJECT_ANALYSIS_VERSIONS.table.title'),
            columns: [
                {itemKey: '', header: this.translateService.instant('PAGE_PROJECT_ANALYSIS_VERSIONS.table.versionId')},
                {itemKey: '', header: this.translateService.instant('PAGE_PROJECT_ANALYSIS_VERSIONS.table.projectType')},
                {itemKey: '', header: this.translateService.instant('PAGE_PROJECT_ANALYSIS_VERSIONS.table.status')},
                {itemKey: '', header: this.translateService.instant('PAGE_PROJECT_ANALYSIS_VERSIONS.table.publishedAt')},
                {itemKey: '', header: ''}
            ]
        };
    }

    public openPublishModal(selectedElement: ProjectAnalysisVersion): void {
        const modal = this.modalService.open(PublishQuickScanVersionModalComponent, {data: selectedElement});
        modal.afterClosed.subscribe((isSubmitted) => {
            if (isSubmitted === true) {
                this.definitionService.publishDefinition(selectedElement.projectType?.id, selectedElement.versionId).subscribe(() => {
                    this.loadVersions();
                });
            }
        });
    }

    public editDefinition(item: ProjectAnalysisVersion): void {
        this.router.navigate(['/beheer', 'project-analysis', item.projectType?.id, item.versionId]);
    }


    private loadVersions() {
        this.loadingSpinnerService.show();
        this.versions$ = this.definitionService.getVersions(this.projectTypeId).pipe(
            map((items) => [...items].sort((a, b) => b.versionId - a.versionId)),
            finalize(() => this.loadingSpinnerService.hide())
        );
    }
}
